import triggerTracking from '@blueprint/tracking';
import { ECommerceEvent } from '@blueprint/tracking/dist/Tracking';
import {
    AnalyticsEcommerce,
    AnalyticsEcommerceImpression
} from '../SearchContext';
import { TrackingCategory } from './Listings.types';

export const nextImageTracking = (listingId: string) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'next_image',
        eventLabel: listingId
    });
};

export const previousImageTracking = (listingId: string) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'previous_image',
        eventLabel: listingId
    });
};

export const hoverImageTracking = (listingId: string) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'hover_image',
        eventLabel: listingId
    });
};

export const agentLogoTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'clickthrough',
        eventLabel: 'listing_agent_logo'
    });
};

export const agentPhoneTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'call',
        eventLabel: 'branch_id'
    });
};

export const phoneNumberRevealTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'click',
        eventLabel: 'reveal agent number'
    });
};

export const agentContactTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'contact_agent'
    });
};

export const listingTitleTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'listing_title'
    });
};

export const listingPriceTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'listing_price'
    });
};

export const listingDescriptionTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'listing_description'
    });
};

export const listingSpecTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'listing_spec'
    });
};

export const listingTransportTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'listing_transport'
    });
};

export const favouriteTracking = (
    isFavourite: boolean,
    trackingCategory: TrackingCategory
) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: trackingCategory,
        eventAction: isFavourite ? 'remove' : 'save',
        eventLabel: 'save listing'
    });
};

export const listingCardTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'property_card'
    });
};

export const imageTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'listing_image'
    });
};

export const ecommerceClickTracking = (
    productImpression: AnalyticsEcommerceImpression,
    listName = 'Search results'
) => {
    triggerTracking({
        event: 'GAEventEcommerce',
        ecommerce: {
            click: {
                actionField: {
                    list: listName
                },
                products: [
                    {
                        id: productImpression.id,
                        variant: productImpression.variant,
                        position: productImpression.position
                    }
                ]
            }
        }
    } as ECommerceEvent);
};

export const getEcommerceDataForListing = (
    analyticsEcommerce: AnalyticsEcommerce,
    listingId: string
) =>
    analyticsEcommerce.impressions?.find(
        (product) => product.id.toString() === listingId
    );
